import api from './api'

export interface User {
  id: string
  email: string
  name: string | null
  role: 'owner' | 'admin' | 'agent' | 'viewer'
  tenantId?: string
  teams: Array<{
    id: string
    name: string
  }>
  createdAt: string
}

export interface CreateUserData {
  email: string
  name: string
  role: 'owner' | 'admin' | 'agent' | 'viewer'
  teamIds?: string[]
  password?: string
}

export interface UpdateUserData {
  name?: string
  role?: 'owner' | 'admin' | 'agent' | 'viewer'
  teamIds?: string[]
}

export const usersApi = {
  /**
   * Get all users for the current tenant
   */
  async getUsers(tenantId?: string): Promise<User[]> {
    const response = await api.get<{ success: boolean; users: User[] }>('/users', {
      headers: tenantId ? { 'x-tenant-id': tenantId } : undefined,
      params: tenantId ? { tenantId } : undefined,
    })
    return response.data.users
  },

  /**
   * Get a single user by ID
   */
  async getUserById(userId: string): Promise<User> {
    const response = await api.get<{ success: boolean; user: User }>(`/users/${userId}`)
    return response.data.user
  },

  /**
   * Create/invite a new user
   */
  async createUser(data: CreateUserData): Promise<User> {
    const response = await api.post<{ success: boolean; user: User }>('/users', data)
    return response.data.user
  },

  /**
   * Update a user
   */
  async updateUser(userId: string, data: UpdateUserData): Promise<User> {
    const response = await api.put<{ success: boolean; user: User }>(`/users/${userId}`, data)
    return response.data.user
  },

  /**
   * Remove a user from the tenant
   */
  async removeUser(userId: string): Promise<void> {
    await api.delete(`/users/${userId}`)
  },
}

